<template>
    <v-container fluid class="fullHeight scrollableContent">
        <v-container>
            <v-row>
                <v-col cols="12" sm="8" lg="6" class="offset-sm-2 offset-lg-3 bordered">
                    <div class="d-flex flex-column mb-8">
                        <div class="d-flex justify-start">
                            <v-img max-width="100px" height="auto" contain :src="logoPath"></v-img>
                        </div>
                    </div>

                    <SuccessMessage v-if="successMessage.type != null" :type="successMessage.type"
                        :title="successMessage.title" :subtitle="successMessage.subtitle"
                        :actionPrimary="successMessage.actionPrimary" />

                </v-col>
            </v-row>
        </v-container>
    </v-container>
</template>

<script>
import SuccessMessage from '@/components/SuccessMessage/SuccessMessage'
import { mapGetters } from 'vuex';
export default {
    name: 'RedsysResult',
    components: {
        SuccessMessage
    },
    data() {
        return {
            payment_id: null,
            payment_status: null,
            successMessage: {
                type: null,
                title: null,
                subtitle: null,
                actionPrimary: {
                    text: 'Regresar', callback() {
                        const currentUrl = window.location.href;
                        const indexOfRedsys = currentUrl.indexOf('/redsys');
                        const url = `${currentUrl.slice(0, indexOfRedsys)}`
                        window.location.href = url
                    }
                }
            },
        }
    },
    async mounted() {
        this.payment_status = 'approved'
        this.successMessage.type = 'success'
        this.successMessage.title = `El pago fue acreditado correctamente!`
    },
    computed: {
        ...mapGetters({
            logoPath: 'commons/getSimpleLogoImageUrl',
        }),
    },
}
</script>

<style scoped>
.bordered {
    border: 1px solid #000000;
    border-radius: 4px;
}
</style>